import script from "./LatestInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatestInformation.vue?vue&type=script&lang=ts&setup=true"

import "./LatestInformation.vue?vue&type=style&index=0&id=b8470ef2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8470ef2"]])

export default __exports__